import React, { FC, useState } from 'react';
import { FeedbackEntity } from '../types';
import Rating from '@mui/material/Rating';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import styles from './NewFeedbackDialog.module.css';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import { logEvent as logAnalyticsEvent } from '../analytics';
import { logEvent, getConversationId } from '../logging';
import { Session } from '../types';
import feedbackConfig from '../resources/feedback.json';

export const NewFeedbackDialog: FC<{
    feedbackEntity: FeedbackEntity;
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    triggerSource: string;
    session?: Session;
}> = ({ isOpen, setIsOpen, triggerSource, session }) => {
    const [rating, setRating] = useState<number | null>(null);
    const [textFeedback, setTextFeedback] = useState<string>('');

    const handleClose = () => {
        logAnalyticsEvent('Feedback - Skipped');
        setIsOpen(false);
    };
    const handleSubmit = () => {
        logAnalyticsEvent('Feedback - Rating Submitted', {
            rating_score: rating,
            ...(triggerSource && { triggerSource }),
        });
        if (textFeedback) {
            logEvent({
                name: 'Feedback Intent Utterances',
                properties: {
                    feedback: textFeedback,
                    conversation_id: getConversationId(),
                    user_id: session?.userId,
                },
            });
        }

        setIsOpen(false);
    };

    const showFeedbackInput = rating && rating <= 3;

    return (
        <Dialog
            classes={{
                container: styles.dialogContainer,
                root: styles.dialogRoot,
                paper: styles.dialogPaper,
            }}
            onClose={handleClose}
            open={isOpen}
        >
            <DialogContent className={styles.dialogContent}>
                <p className={styles.ratingTitle}>
                    {feedbackConfig.providence.howRateExperience}
                </p>
                <Rating
                    name="simple-controlled"
                    value={rating}
                    size="large"
                    className={styles.rating}
                    classes={{ icon: styles.ratingIcon }}
                    onChange={(event, newValue) => {
                        setRating(newValue);
                    }}
                />
                {showFeedbackInput && (
                    <>
                        <p className={styles.improveTitle}>
                            {feedbackConfig.providence.howImproveExperience}
                        </p>
                        <label
                            className={styles.hiddenInputLabel}
                            htmlFor="experienceInput"
                        >
                            Feedback input
                        </label>
                        <TextField
                            inputProps={{
                                id: 'experienceInput',
                                name: 'experienceInput',
                            }}
                            hiddenLabel={true}
                            multiline
                            value={textFeedback}
                            onChange={(e) => setTextFeedback(e.target.value)}
                            rows={2}
                            className={styles.textInput}
                        />
                    </>
                )}
                <Button
                    className={styles.confirmButton}
                    variant="contained"
                    onClick={handleSubmit}
                    sx={{
                        '&.Mui-disabled': {
                            backgroundColor: 'rgba(0, 51, 142, 0.4)',
                            color: 'white',
                        },
                        ':hover': {
                            backgroundColor: '#335BA4',
                            boxShadow: 'none',
                        },
                    }}
                >
                    {rating === null
                        ? feedbackConfig.providence.skipAndClose
                        : feedbackConfig.providence.submit}
                </Button>
            </DialogContent>
        </Dialog>
    );
};
